import { useState } from "react";
import SellerStep from "../../components/seller/SellerStep";
import Accordion from "../../components/widgets/Accordion";
import ChoiceGroup from "../../components/forms/ChoiceGroup";
import { useSellerState } from "../../js/state/sellerState";

export const TIPS = [
  {
    id: "prep",
    title: "Preparing the home to list",
    content: (
      <div>
        <p>
          Buyers decide in the first photos and the first thirty seconds on site. Clean, clear
          surfaces and working lights outperform most last-minute renovations.
        </p>
        <ul>
          <li>Finish small repairs that photograph poorly: missing hardware, cracked switch plates, stained grout.</li>
          <li>Edit personal photos and collections so rooms read as spaces, not biographies.</li>
          <li>Walk the curb at listing-photo time of day and fix what that angle actually shows.</li>
        </ul>
      </div>
    ),
  },
  {
    id: "pricing",
    title: "Pricing and expectations",
    content: (
      <div>
        <p>
          Your agent prices to the market, not to what you have invested. This portfolio is the
          evidence for that conversation — upgrades, condition, and competing inventory.
        </p>
        <ul>
          <li>Ask for a net sheet early so list price and take-home are not confused.</li>
          <li>Activity in the first two weeks is data. Quiet listings rarely “need more time”; they need a strategy change.</li>
          <li>Credits and repairs after inspection are common. Decide your as-is vs. fix line before you are in a bid.</li>
        </ul>
      </div>
    ),
  },
  {
    id: "showings",
    title: "Showings and communication",
    content: (
      <div>
        <p>Access and feedback loops sell homes. Delayed showings and vague answers slow offers.</p>
        <ul>
          <li>Leave during showings when you can. Buyers speak more honestly without the owner in the room.</li>
          <li>Reply the same day on time-sensitive requests: second showings, inspection windows, HOA docs.</li>
          <li>Tell your agent about pets, alarms, and parking so the showing notes stay accurate.</li>
        </ul>
      </div>
    ),
  },
  {
    id: "fair-housing",
    title: "Fair Housing on the seller side",
    content: (
      <div>
        <p>
          Marketing and showing decisions cannot be based on race, color, national origin, religion,
          sex (including gender identity and sexual orientation), familial status, or disability.
        </p>
        <ul>
          <li>Describe the property and terms — not who you hope will buy it or who lives nearby.</li>
          <li>Keep showing rules consistent for every buyer’s agent. Informal “preferences” are still illegal screening.</li>
          <li>Accessibility questions belong in features and condition, not in who is “a good fit.”</li>
        </ul>
      </div>
    ),
  },
];

export default function SellerTips() {
  const saved = useSellerState().seller.portfolio.tips || {};
  const [form, setForm] = useState({
    acknowledged: saved.acknowledged || "",
  });

  return (
    <SellerStep
      title="Seller tips"
      lead="How to help your Agent gain top results with buyers by following these legal and effective tips for selling your house."
      sectionKey="tips"
      value={form}
      continueLabel="Continue to summary"
    >
      <Accordion items={TIPS} />
      <ChoiceGroup
        label="I have reviewed these tips"
        name="acknowledged"
        value={form.acknowledged}
        onChange={(event) => setForm({ acknowledged: event.target.value })}
        options={[
          { value: "yes", label: "Yes, I have read them" },
          { value: "later", label: "I will come back" },
        ]}
      />
    </SellerStep>
  );
}
